let finishing: Promise<void> | undefined;
const delay = (ms: number) =>
  new Promise<void>((resolve) => window.setTimeout(resolve, ms));

export function updateEntryLoading(text: {
  label: string;
  message: string;
  helpMessage?: string;
  home?: string;
}) {
  document
    .getElementById('glow-entry-loading')
    ?.setAttribute('aria-label', text.label);
  const message = document.getElementById('glow-entry-message');
  if (message) message.textContent = text.message;
  const help = document.getElementById('glow-entry-recovery-message');
  if (help && text.helpMessage) help.textContent = text.helpMessage;
  const home = document.getElementById('glow-entry-recovery-home');
  if (home && text.home) home.textContent = text.home;
}

/** Only the decorative homepage image can hold the entry cover, for at most 1.8 seconds. */
async function waitForBrandImage() {
  const image = document.querySelector<HTMLImageElement>(
    'img[data-entry-image]',
  );
  if (!image || (image.complete && image.naturalWidth > 0)) return;
  let timeout: number | undefined;
  try {
    await Promise.race([
      image.decode().catch(() => undefined),
      new Promise<void>((resolve) => {
        timeout = window.setTimeout(resolve, 1800);
      }),
    ]);
  } finally {
    window.clearTimeout(timeout);
  }
}

export function finishEntryLoading(): Promise<void> {
  const cover = document.getElementById('glow-entry-loading');
  if (!cover) return Promise.resolve();
  if (finishing) return finishing;
  finishing = (async () => {
    const reducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)',
    ).matches;
    // The route is ready; only the bounded image preparation can delay opening it.
    await waitForBrandImage();
    // 페이드아웃 장식은 화면을 여는 순간 접근성 트리/포커스에서 제외한다.
    cover.setAttribute('aria-hidden', 'true');
    cover.setAttribute('aria-live', 'off');
    cover.setAttribute('inert', '');
    const root = document.getElementById('root');
    root?.removeAttribute('inert');
    root?.removeAttribute('aria-busy');
    if (!reducedMotion) {
      cover.classList.add('gp-entry-loading--ready');
      await delay(260);
    }
    cover.remove();
  })().finally(() => {
    finishing = undefined;
  });
  return finishing;
}

/** Bootstrap errors stay actionable and never expose exception text or leave a fake spinner. */
export function showEntryFailure(text: { message: string; retry: string }) {
  const cover = document.getElementById('glow-entry-loading');
  cover?.setAttribute('role', 'alert');
  cover?.removeAttribute('aria-label');
  cover?.classList.add('gp-entry-loading--failed');
  const message = document.getElementById('glow-entry-message');
  if (message) message.textContent = text.message;
  const retry = document.getElementById('glow-entry-retry');
  if (retry) {
    retry.textContent = text.retry;
    retry.hidden = false;
    retry.addEventListener('click', () => window.location.reload(), {
      once: true,
    });
  }
}
